import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../graphql";
import PropTypes from "prop-types";
import { Spin, Row, Col, Button, Form, Modal } from "antd";
import Container from "../../../../components/user/Container";
import ModalConfirmForm from "../../../../components/user/ModalConfirmForm";
import SecProfileInformation from "../sector/SecProfileInfomation";
import SecDocumentInformation from "../sector/SecDocumentInformation";
import SecAttachment from "../sector/SecAttachment";
import SecApproverHistory from "../sector/SecApproverHistory";
import { checkStatusForm } from "../../../../utils/abstainTime";
import { UrlAbstainTime, getToken } from "../../../../utils/auth";
import { apiKeyNews } from "../../../../utils/apiKey";
import axios from "axios";
import moment from "moment";
import { transformToFormData } from "../../../../utils/formData";
import { alertMessage } from "../../../../utils/message";

class FormLeaveCancel extends Component {
  state = {
    dataAbstain: null,
    preLoadOnsubmit: false,
    dataTalbeUploads: [],
    loadingFullpage: true,
    isEdit: true,
    dropdownListApprover: [],
    dataEmployeeOrg: [],
    formTocreate: true,
  };

  handleSubmitCancel = async (e) => {
    window.location.href = "/AbstainTime/Dashboard";
    // this.sendToCreateLeave(e, 'DRAFT')
  };

  showModalFormConfirm = async (values, messageShow, title, textBtnOK) => {
    const { form, client } = this.props;

    await this.setState({
      ModalConfirmFormTitle: messageShow,
      ModalConfirmFormSubTitle: title,
      ModalConfirmFormShowModal: true,
      ModalConfirmFormBtnOk: textBtnOK,
      ModalConfirmFormBtnCancel: "ยกเลิก",
      ModalConfirmFormValue: values,
    });
  };

  hideModalConfirm = async () => {
    await this.setState({
      ModalConfirmFormTitle: null,
      ModalConfirmFormSubTitle: null,
      ModalConfirmFormShowModal: false,
      ModalConfirmFormBtnOk: null,
      ModalConfirmFormBtnCancel: null,
      ModalConfirmFormValue: null,
    });
  };

  handleSubmit = async (e, statusSend) => {
    const { form, match } = this.props;
    const { dataAbstain, dataProfile, dataEmployeeOrg } = this.state;

    e.preventDefault();

    form.validateFields(async (err, values) => {
      console.log("xczzxczcz handlesub", values);
      console.log("dataAbstain handlesub", dataAbstain);

      if (err) {
        Modal.error({
          className: "modalFickIcons",
          title:
            statusSend == "draft"
              ? "บันทึกร่างไม่สำเร็จ"
              : "ส่งดำเนินการไม่สำเร็จ",
          width: "600px",
          content: <h3 className="mt-3">กรุณาระบุข้อมูลให้ครบถ้วน</h3>,
          okText: "ปิด",
          onOk() {},
        });
      } else {
        let returnArray = [];
        let returnNoValidate = false;

        if (values.tbAbstainTimeDt?.length > 0) {
          console.log("hi if tb", values.tbAbstainTimeDt);
          values.tbAbstainTimeDt.map((valueReturn, keys) => {
            if (valueReturn.abTimeDtId) {
              delete valueReturn.isValidate;
                delete valueReturn.disabledRow;
                delete valueReturn.isShowEditButton;
                delete valueReturn.isShowSaveButton;

                valueReturn.endAbstainDate = valueReturn.startAbstainDate
                valueReturn.timeIn = valueReturn.timeIn  ? moment(valueReturn.timeIn).format("HH:mm").toString() : null
                valueReturn.timeOut = valueReturn.timeOut ? moment(valueReturn.timeOut).format("HH:mm").toString() : null
                valueReturn.abstainDays = "1"
              returnArray.push(valueReturn);
            } else {
              console.log("hi if tb out isValidate", values.tbAbstainTimeDt);
              if (valueReturn.isValidate) {
                console.log("hi if tb isValidate", values.tbAbstainTimeDt);
                delete valueReturn.isValidate;
                delete valueReturn.disabledRow;
                delete valueReturn.isShowEditButton;
                delete valueReturn.isShowSaveButton;
                
                valueReturn.endAbstainDate = valueReturn.startAbstainDate
                valueReturn.timeIn = valueReturn.timeIn  ? moment(valueReturn.timeIn).format("HH:mm").toString() : null
                valueReturn.timeOut = valueReturn.timeOut ? moment(valueReturn.timeOut).format("HH:mm").toString() : null
                valueReturn.abstainDays = "1"

                returnArray.push(valueReturn);
              } else {
                returnNoValidate = true;
              }
            }
          });
          values.tbAbstainTimeDt = returnArray;
        }

        console.log("alues.tbAbstainTimeDt", returnArray);

        if (!values.tbApprover || values.tbApprover.length == 0) {
          Modal.error({
            className: "modalFickIcons",
            title:
              statusSend == "draft"
                ? "บันทึกร่างไม่สำเร็จ"
                : "ส่งดำเนินการไม่สำเร็จ",
            width: "600px",
            content: (
              <h3 className="mt-3">
                ไม่พบข้อมูลการตั้งค่าผู้อนุมัติ กรุณาติดต่อผู้ดูแลระบบ
              </h3>
            ),
            okText: "ปิด",
            onOk() {},
          });
        } else if (returnNoValidate) {
          console.log("actionSubmit return no validate");
          Modal.error({
            className: "modalFickIcons",
            title: "ส่งดำเนินการไม่สำเร็จ",
            width: "600px",
            content: (
              <h3 className="mt-3">
                มีข้อมูลแก้ไขการลงเวลาทำงานที่ยังไม่ถูกบันทึก
              </h3>
            ),
            okText: "ปิด",
            onOk() {},
          });
        } else if (!values.tbAbstainTimeDt || values.tbAbstainTimeDt.length == 0) {
          Modal.error({
            className: "modalFickIcons",
            title:
              statusSend == "draft"
                ? "บันทึกร่างไม่สำเร็จ"
                : "ส่งดำเนินการไม่สำเร็จ",
            width: "600px",
            content: (
              <h3 className="mt-3">กรุณาระบุข้อมูลวันที่ขอแก้ไขการลงเวลาทำงาน</h3>
            ),
            okText: "ปิด",
            onOk() {},
          });
        }
        else {
          if (match.url.split("/")[4]) {
            values.abTimeHdId = dataAbstain.abTimeHdId;
            values.empCode = dataAbstain.empCode;
            values.title = dataAbstain.title;
            values.firstName = dataAbstain.firstName;
            values.lastName = dataAbstain.lastName;
            values.buCode = dataAbstain.buCode;
            values.buName = dataAbstain.buName;
            values.divisionCode = dataAbstain.divisionCode;
            values.divisionName = dataAbstain.divisionName;
            values.orgUnitCode = dataAbstain.orgUnitCode;
            values.orgUnitName = dataAbstain.orgUnitName;
            values.positionCode = dataAbstain.positionCode;
            values.positionName = dataAbstain.positionName;
            values.clientType = "WEB_CLIENT";
            values.approveStatus =
              statusSend == "submit" ? "pending" : statusSend;
            values.requestBy = dataAbstain.requestBy;
            values.requestAt = moment().format("YYYY-MM-DD");

            if (values.abstainTimeDelete) {
              console.log("abstainTimeDelete", values.abstainTimeDelete);
              const dataDateDelete = values.abstainTimeDelete;

              dataAbstain.tbAbstainTimeDt.map((valuesTable, keys) => {
                if (
                  dataDateDelete.some(
                    (dataDateDelete) => dataDateDelete == valuesTable.abTimeDtId
                  )
                ) {
                  valuesTable.isDeleted = true;
                  if (!values.tbAbstainTimeDt) {
                    values.tbAbstainTimeDt = [];
                  }
                  values.tbAbstainTimeDt.push(valuesTable);
                }
              });
              console.log("values.tbAbstainTimeDt", values.tbAbstainTimeDt);
            }

            if (values.arrayFileDelete) {
              console.log("arrayFileDelete", values.arrayFileDelete);
              const dataDateDelete = values.arrayFileDelete;

              dataAbstain.tbAttachFile.map((valuesTable, keys) => {
                if (
                  dataDateDelete.some(
                    (dataDateDelete) =>
                      dataDateDelete == valuesTable.attachFileId
                  )
                ) {
                  valuesTable.isDeleted = true;
                  if (!values.attachFile) {
                    values.attachFile = [];
                  }
                  values.attachFile.push(valuesTable);
                }
              });
              console.log("values.attachFile", values.attachFile);
            }
          } else {
            values.empCode = dataProfile.employeeCodes[0];
            values.title = dataEmployeeOrg.titleName;
            values.firstName = dataEmployeeOrg.firstName;
            values.lastName = dataEmployeeOrg.lastName;
            values.buCode = dataEmployeeOrg.buCode;
            values.buName = dataEmployeeOrg.buName;
            values.divisionCode = dataEmployeeOrg.divisionCode;
            values.divisionName = dataEmployeeOrg.divisionName;
            values.orgUnitCode = dataEmployeeOrg.orgUnitCode;
            values.orgUnitName = dataEmployeeOrg.orgUnitName;
            values.positionCode = dataEmployeeOrg.positionCode;
            values.positionName = dataEmployeeOrg.positionName;
            values.clientType = "WEB_CLIENT";
            values.approveStatus =
              statusSend == "submit" ? "pending" : statusSend;
            values.requestBy = dataProfile.personId;
            values.requestAt = moment().format("YYYY-MM-DD");
          }
          if (statusSend !== "draft") {
            await this.showModalFormConfirm(
              values,
              "ท่านต้องการยื่นเรื่องขอแก้ไขการลงเวลาทำงาน?",
              "",
              "ตกลง"
            );
          } else {
            await this.sendToCreateLeaveDoc(values);
          }
        }
      }
    });
  };

  sendToCreateLeaveDoc = async (values) => {
    const { match } = this.props;
    const { dataAbstain, dataProfile, dataEmployeeOrg } = this.state;

    console.log("sendToCreateLeaveDoc", values);
    //const attachFile = [];
    delete values.ModalNoteApprove;
    delete values.approveStatusStr;
    delete values.empFullName;

    let newFileCheck = false;
    let oldFileCheck = false;

    if (values.abstainTimeDelete) {
      delete values.abstainTimeDelete;
    }

    if (values.arrayFileDelete) {
      delete values.arrayFileDelete;
    }

    let newAttathFile = [];
    let newAttathFileDB = [];
    const formData = new FormData();

    if (values.attachFile && values.attachFile.length > 0) {
      values.attachFile.forEach((element, index) => {
        console.log(`looppp ${index} - ${element.attachFileId}`);
        if (element.attachFileId) {
          let obj2 = {
            // attachFileId: element.attachFileId,
            sort: index + 1,
            ...element,
            // documentType: element.typeDoc,
            // filePath: {
            //   fileName: element.fileName,
            //   file: element.file[0],
            //   fileType: element.fileType,
            // },
            // fileName: element.fileName,
            // fileType: element.fileType,,
            // description: element.desc,
            // file: element.file[0],
            // ...dataAbstain.tbAttachFile[index]
          };
          newAttathFileDB.push(obj2);
          oldFileCheck = true;
          //formData.append("abstainTimeFiles", element.fileData);
        } else {
          console.log(`looppp ${index} - ${element.attachFileId} - inelse`);
          let obj = {
            sort: index + 1,
            documentType: element.documentType,
            filePath: {
              fileName: element.file[0].name,
              file: element.file[0],
              fileType: element.file[0].type,
            },
            fileName: element.file[0].name,
            fileType: element.file[0].type,
            description: element.description,
            file: element.file[0],
          };
          newAttathFile.push(obj);
          formData.append("abstainTimeFiles", element.file[0]);
          newFileCheck = true;
        }
      });
    }

    console.log("newfilecheck", newFileCheck);

    let arrayFileFinal = [];
    if (oldFileCheck) {
      console.log("newAttathFileDB", newAttathFileDB);
      arrayFileFinal = newAttathFile.concat(newAttathFileDB);
    } else {
      arrayFileFinal = newAttathFile;
    }

    console.log("arrayFileFinal", arrayFileFinal);

    let newValue = {
      ...values,
      tbAttachFile: arrayFileFinal ? arrayFileFinal : [],
      attachFile: newAttathFile ? newAttathFile : [],
    };

    // let newValue = {
    //   ...values,
    //   tbAttachFile: newAttathFile ? newAttathFile : [],
    //   attachFile: newAttathFile ? newAttathFile : [],
    // };

    console.log("newValue", newValue);
    formData.append("tbAbstainTimeHd", JSON.stringify(newValue));

    console.log("TEST formdata", formData.getAll(""));
    console.log("TEST formdata file", formData.getAll("abstainTimeFiles"));

    const { token } = getToken();
    const API_DEVICE_KEY = atob(apiKeyNews());

    await this.setState({
      loadingFullpage: true,
    });

    const headers = {
      //"Content-Type": 'multipart/form-data',
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    if (match.url.split("/")[4]) {
      console.log("formData loggg", formData);

      // const response = await axios
      //   .post(`${UrlAbstainTime()}/updateAbstainTime`, formData, {
      //     headers: headers,
      //   })
      //   console.log("formData loggg 22",response)
      console.log("headers loggg", {
        "Content-Type": "multipart/form-data",
        ...headers,
      });

      // axios ({ url : `${UrlAbstainTime()}/updateAbstainTime`,
      //   method : 'POST',
      //   headers : {'Content-Type': 'multipart/form-data',...headers},
      //   data : formData
      // })
      axios
        .post(`${UrlAbstainTime()}/updateAbstainTime`, formData, {
          headers: headers,
        })
        .then(async (response) => {
          console.log("response", response);
          await this.setState({
            loadingFullpage: false,
            loading: false,
          });
          if (response.data.data) {
            console.log("values.approveStatus", values.approveStatus);
            if (values.approveStatus == "draft") {
              alertMessage("success", "บันทึกร่างสำเร็จ");
              setTimeout(() => {
                window.location.href = "/AbstainTime/Dashboard/";
              }, 2000);
            } else {
              alertMessage("success", "ยื่นเรื่องสำเร็จ");
              setTimeout(() => {
                this.hideModalConfirm();
                window.location.href = "/AbstainTime/Dashboard/";
              }, 2000);
            }
          } else {
            if (response.data.message.includes("ทับซ้อน")) {
              alertMessage("error", response.data.message);
            } else {
              alertMessage("error", "บางอย่างผิดพลาด กรุณาลองใหม่อีกครั้ง");
            }
            this.hideModalConfirm();
          }
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
          this.hideModalConfirm();
        });
    } else {
      axios
        .post(`${UrlAbstainTime()}/createAbstainTime`, formData, {
          headers: headers,
        })
        .then(async (response) => {
          console.log("response", response.data.data);
          await this.setState({
            loadingFullpage: false,
            loading: false,
          });
          if (response.data.status) {
            let checkShowMessage =
              values.approveStatus == "draft" ? "บันทึกร่าง" : "ยื่นเรื่อง";
            if (response.data.status) {
              alertMessage("success", checkShowMessage + "สำเร็จ");
              setTimeout(() => {
                window.location.href = "/AbstainTime/Dashboard/";
              }, 2000);
            } else {
              alertMessage(
                "error",
                "ไม่สามารถทำการ" + checkShowMessage + "ได้"
              );
            }
          } else {
            if (response.data.message.includes("ทับซ้อน")) {
              alertMessage("error", response.data.message);
            } else {
              //   alertMessage("error", "บางอย่างผิดพลาด กรุณาลองใหม่อีกครั้ง");
            }
            this.hideModalConfirm();
          }
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
          this.hideModalConfirm();
        });
    }
  };

  fetchAbstainTimeById = async () => {
    const { token } = getToken();
    const { match } = this.props;
    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    console.log('match.url.split("/")[4]', match.url.split("/")[4]);
    axios
      .post(
        `${UrlAbstainTime()}/fetchAbstainTimeForStaffById`,
        {
          abTimeHdId: match.url.split("/")[4],
        },
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        console.log("response.data", response.data.data);
        await this.setState({
          dataAbstain: response.data.data,
          loadingFullpage: false,
          isEdit: response.data.data.approveStatus == "draft" ? true : false,
        });
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  fetchDropDownMasterData = async (dropDownType) => {
    const { client, location, match } = this.props;
    const { empCode } = this.state;

    let dropDownRetrue = [];
    try {
      const { data, errors } = await client.query({
        query: Queries.fetchDropDownMasterData,
        variables: {
          dropDownType,
        },
      });

      await data.fetchDropDownMasterData.map((values, keys) => {
        dropDownRetrue.push({
          value: values.id,
          label: values.label,
        });
      });

      await this.setState({
        ["dropDownType" + dropDownType]: dropDownRetrue,
      });
      // return dropDownRetrue;
    } catch (error) {
      console.log(error);
      return dropDownRetrue;
    }
  };

  // fetchListApprove = async () => {
  //   const list_approver = [
  //     {
  //       level: 1,
  //       role: "approver",
  //       canEdit: false,
  //       userList: [
  //         {
  //           empCode: "3204003",
  //           label: "ศาสตราจารย์นายแพทย์กีอะฟงษ์ กัธฑกิเชีรอ",
  //           empName: "ศาสตราจารย์นายแพทย์กีอะฟงษ์ กัธฑกิเชีรอ",
  //           positionCode: "1003",
  //           positionName: "เจ้าหน้าที่พัสดุ",
  //         },
  //         {
  //           empCode: "9000002",
  //           label: "ศ.กิตติคุณ นายแพทย์กิษิสฏ์",
  //           empName: "ศ.กิตติคุณ นายแพทย์กิษิสฏ์",
  //           positionCode: "1004",
  //           positionName: "เจ้าหน้าที่พัสดุ2",
  //         },
  //       ],
  //     },
  //     {
  //       level: 2,
  //       role: "reviewer",
  //       canEdit: false,
  //       userList: [
  //         {
  //           empCode: "3204003",
  //           label: "ศาสตราจารย์นายแพทย์กีอะฟงษ์ กัธฑกิเชีรอ2",
  //           empName: "ศาสตราจารย์นายแพทย์กีอะฟงษ์ กัธฑกิเชีรอ2",
  //           positionCode: "1005",
  //           positionName: "เจ้าหน้าที่คลัง",
  //         },
  //       ],
  //     },
  //   ];

  //   await this.setState({
  //     dropdownListApprover: list_approver,
  //   });
  // };

  fetchListProfile = async () => {
    const { client } = this.props;
    try {
      const { date } = this.state;
      const { data, errors } = await client.query({
        query: Queries.fetchProfile,
      });

      if (data.fetchProfile) {
        console.log("data.fetchProfile", data.fetchProfile);
        await this.setState({
          dataProfile: data.fetchProfile,
        });
        await this.fetchEmployeeDetail();
      } else {
        await this.setState({
          dataProfile: null,
        });
      }
    } catch (error) {
      await this.setState({
        dataProfile: null,
      });
    }
  };

  fetchEmployeeDetail = async () => {
    const { client, location, match } = this.props;
    const { dataProfile } = this.state;
    const { data, errors } = await client.query({
      query: Queries.fetchEmployeeDetail,
      variables: {
        empCode: dataProfile.employeeCodes[0],
      },
    });

    if (data.fetchEmployeeDetail) {
      await this.setState({
        orgCode: data.fetchEmployeeDetail.orgCode,
      });
      console.log(
        "data.fetchEmployeeDetail.orgCode",
        data.fetchEmployeeDetail.orgCode
      );
      await this.fetchEmpAbstainTime();
    } else {
      await this.setState({
        detailProfile: null,
      });
    }
  };

  fetchEmpAbstainTime = async () => {
    const { token } = getToken();
    const { dataProfile, orgCode } = this.state;

    console.log("fetchEmpAbstainTime empcode", dataProfile.employeeCodes[0]);
    console.log("fetchEmpAbstainTime orgCode", orgCode);

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .post(
        `${UrlAbstainTime()}/fetchEmpAbstainTime`,
        {
          empCode: dataProfile.employeeCodes[0],
          orgCode: orgCode,
          isAdmin: true,
        },
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        console.log("data fetchEmpAbstainTime by org api", response.data);

        await this.setState({
          dropdownListApprover: response.data.data?.tbApprover
            ? response.data.data?.tbApprover
            : [],
          dataEmployeeOrg: response.data.data,
        });
      })

      .catch((error) => console.error(`Error: ${error}`));
  };

  getAbstainApproverList = async () => {
    const { token } = getToken();
    const { dataProfile, orgCode } = this.state;

    console.log("getAbstainApproverList empcode", dataProfile.employeeCodes[0]);
    console.log("getAbstainApproverList orgCode", orgCode);

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .get(
        `${UrlAbstainTime()}/getAbstainApproverList?empCode=${
          dataProfile.employeeCodes[0]
        }&orgCode=${orgCode}`,

        {
          headers: headers,
        }
      )

      .then(async (response) => {
        console.log("response.data", response.data.data);
        await this.setState({
          dropdownListApprover: response.data.data,
          loading: false,
        });
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  checkShowBtnSubmit = () => {
    const { dataAbstain } = this.state;
    if (dataAbstain.status == "approve") {
      return true;
    } else if (dataAbstain.status == "draft") {
      return false;
    } else if (dataAbstain.status == "pending") {
      return true;
    } else {
      return false;
    }
  };

  checkShowForm = () => {
    const { dataAbstain, formTocreate } = this.state;
    if (dataAbstain) {
      return true;
    } else {
      if (formTocreate) {
        return false;
      } else {
        return true;
      }
    }
  };

  async componentDidMount() {
    const { match } = this.props;
    const { dataAbstain, dataEmployeeOrg } = this.state;

    await this.fetchListProfile();
    await this.fetchDropDownMasterData("abstainTimeDocType");
    //  await this.getAbstainApproverList();
    // await this.fetchListApprove();

    if (dataEmployeeOrg) {
      if (match.url.split("/")[4]) {
        console.log("match.url", match.url.split("/")[4]);
        await this.fetchAbstainTimeById();
      } else {
        this.setState({
          isEdit: true,
          loadingFullpage: false,
          formTocreate: false,
        });
      }
    }
  }

  render() {
    const { match } = this.props;
    const {
      detailForm,
      preLoadOnsubmit,
      ModalConfirmFormTitle,
      ModalConfirmFormSubTitle,
      ModalConfirmFormShowModal,
      ModalConfirmFormBtnOk,
      ModalConfirmFormBtnCancel,
      ModalConfirmFormValue,
      loadingFullpage,
      loginPerson,
      dataAbstain,
      isEdit,
      dropdownListApprover,
      dataEmployeeOrg,
      formTocreate,
      dataProfile,
    } = this.state;

    console.log("dataabstain", dataAbstain);

    return (
      <Container match={match}>
        <div className="breadcrumb-custom pb-3 mb-5">
          {  match.url.split("/")[4] ?  <span style={{ fontSize: "18px" }}>การแก้ไขการลงเวลาทำงาน / แก้ไขเอกสารแก้ไขการลงเวลาทำงาน</span> :
           <span style={{ fontSize: "18px" }}>การแก้ไขการลงเวลาทำงาน / สร้างเอกสารแก้ไขการลงเวลาทำงาน</span> 
          }
         
        </div>
        <ModalConfirmForm
          title={ModalConfirmFormTitle}
          subtitle={ModalConfirmFormSubTitle}
          showModal={ModalConfirmFormShowModal}
          btnOk={ModalConfirmFormBtnOk}
          btnCancel={ModalConfirmFormBtnCancel}
          submitToSend={this.sendToCreateLeaveDoc}
          hideModal={this.hideModalConfirm}
          valueConfirm={ModalConfirmFormValue}
        />
        <Spin spinning={loadingFullpage} delay={500}>
          <div className="card-container h-100" id="page-profile">
            {formTocreate ? (
              <>
                {dataAbstain && (
                  <Form ref={this.formRef}>
                    <div className="px-5 pt-1 pb-4 card-bg-green">
                      <SecProfileInformation
                        loginProfile={loginPerson}
                        propFormInput={this.props.form}
                        rawData={dataAbstain ? dataAbstain : dataEmployeeOrg}
                        isViewOnly={!isEdit}
                      />

                      <SecDocumentInformation
                        loginProfile={loginPerson}
                        propFormInput={this.props.form}
                        rawData={dataAbstain}
                        isViewOnly={!isEdit}
                        form={this.formRef}
                        empCode={dataProfile.employeeCodes[0]}
                      />

                      <SecAttachment
                        loginProfile={loginPerson}
                        propFormInput={this.props.form}
                        rawData={dataAbstain ? dataAbstain.tbAttachFile : []}
                        isViewOnly={!isEdit}
                        form={this.formRef}
                        dropDownTypeDoc={
                          this.state.dropDownTypeabstainTimeDocType
                            ? this.state.dropDownTypeabstainTimeDocType
                            : []
                        }
                      />

                      <SecApproverHistory
                        loginProfile={loginPerson}
                        propFormInput={this.props.form}
                        rawDataApprover={
                          dataAbstain ? dataAbstain.tbApprover : []
                        }
                        rawDataHistory={
                          dataAbstain ? dataAbstain.tbAbstainTimeHistory : []
                        }
                        isViewOnly={!isEdit}
                        form={this.formRef}
                        dropdownListApprover={dropdownListApprover}
                        status={
                          dataAbstain ? dataAbstain.approveStatus : "create"
                        }
                      />

                      <Row
                        gutter={16}
                        type="flex"
                        justify="left"
                        align="top"
                        className=""
                      >
                        <Col xs={24} md={24} className="pt-2" align="center">
                          <Button
                            type="primary"
                            className="mx-2 btn-white-red"
                            onClick={this.handleSubmitCancel}
                            disabled={preLoadOnsubmit}
                          >
                            ย้อนกลับ
                          </Button>
                          {!dataAbstain ||
                          dataAbstain.approveStatus == "draft" ? (
                            <>
                              <Button
                                type="primary"
                                className="mx-2 btn-white-red"
                                onClick={(e) => {
                                  this.handleSubmit(e, "draft");
                                }}
                                disabled={preLoadOnsubmit}
                              >
                                บันทึกร่าง
                              </Button>

                              <Button
                                type="primary"
                                className="ml-2 color-white"
                                htmlType="submit"
                                disabled={preLoadOnsubmit}
                                onClick={(e) => {
                                  this.handleSubmit(e, "submit");
                                }}
                              >
                                ยื่นเรื่อง
                              </Button>
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Form>
                )}
              </>
            ) : (
              <Form ref={this.formRef}>
                <div className="px-5 pt-1 pb-4 card-bg-green">
                  <SecProfileInformation
                    loginProfile={loginPerson}
                    propFormInput={this.props.form}
                    rawData={dataAbstain ? dataAbstain : dataEmployeeOrg}
                    isViewOnly={!isEdit}
                  />

                  <SecDocumentInformation
                    loginProfile={loginPerson}
                    propFormInput={this.props.form}
                    rawData={dataAbstain}
                    isViewOnly={!isEdit}
                    form={this.formRef}
                    empCode={dataProfile?.employeeCodes[0]}
                  />

                  <SecAttachment
                    loginProfile={loginPerson}
                    propFormInput={this.props.form}
                    rawData={dataAbstain ? dataAbstain.tbAttachFile : []}
                    isViewOnly={!isEdit}
                    form={this.formRef}
                    dropDownTypeDoc={
                      this.state.dropDownTypeabstainTimeDocType
                        ? this.state.dropDownTypeabstainTimeDocType
                        : []
                    }
                  />

                  <SecApproverHistory
                    loginProfile={loginPerson}
                    propFormInput={this.props.form}
                    rawDataApprover={dataAbstain ? dataAbstain.tbApprover : []}
                    rawDataHistory={
                      dataAbstain ? dataAbstain.tbAbstainTimeHistory : []
                    }
                    isViewOnly={!isEdit}
                    form={this.formRef}
                    dropdownListApprover={dropdownListApprover}
                    status={dataAbstain ? dataAbstain.approveStatus : "create"}
                  />

                  <Row
                    gutter={16}
                    type="flex"
                    justify="left"
                    align="top"
                    className=""
                  >
                    <Col xs={24} md={24} className="pt-2" align="center">
                      <Button
                        type="primary"
                        className="mx-2 btn-white-red"
                        onClick={this.handleSubmitCancel}
                        disabled={preLoadOnsubmit}
                      >
                        ย้อนกลับ
                      </Button>
                      <Button
                        type="primary"
                        className="mx-2 btn-white-red"
                        onClick={(e) => {
                          this.handleSubmit(e, "draft");
                        }}
                        disabled={preLoadOnsubmit}
                      >
                        บันทึกร่าง
                      </Button>
                      <Button
                        type="primary"
                        className="ml-2 color-white"
                        htmlType="submit"
                        disabled={preLoadOnsubmit}
                        onClick={(e) => {
                          this.handleSubmit(e, "submit");
                        }}
                      >
                        ยื่นเรื่อง
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Form>
            )}
          </div>
        </Spin>
      </Container>
    );
  }
}

FormLeaveCancel.defaultProps = {
  autoFocus: false,
};

FormLeaveCancel.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedFormLeaveCancel = Form.create()(FormLeaveCancel);

export default withApollo(WrappedFormLeaveCancel);
